import { EMPTY_TRANSFER_OF_CHARGE_MODEL } from "presentation/model/TransferOfCharge/TransferOfChargeModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: TransferOfChargeProvider,
    useTracked: useTransferOfChargeTracked
} = createContainer(() => useState(EMPTY_TRANSFER_OF_CHARGE_MODEL), { concurrentMode: true });
export { TransferOfChargeProvider, useTransferOfChargeTracked };

